module.exports = __webpack_public_path__ + "img/DE00615.ebe548b4.png";